// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__2uaji","tabs":"LayoutWrapperSideNav_tabs__tvrFY","tab":"LayoutWrapperSideNav_tab__2x7yM"};